<template>
    <div class="relative">
        <div class="absolute -mt-1 md:-mt-12 pl-1 md:pl-3">
            <i class="text-sm text-green-warm-500 fas fa-equals"></i>
        </div>

        <form-row title="Total Net to Agent"
            :no_border="true"
            class="mt-6 md:-mt-2 mb-6"
            label_class="ml-8 md:ml-0"
        >
            <div class="sm:w-36">
                <input-money
                    name="purchase_side_total_net_to_agent"
                    :value="total_net_to_agent"
                    :read_only="true"
                    tabindex="-1"
                />
            </div>
        </form-row>

        <div class="border-b border-gray-400"></div>
    </div>
</template>

<script>
export default {
    props: {
        total_net_to_agent: { default: null },
        read_only: { default: false },
    },
}
</script>
